export default __webpack_public_path__ + "static/media/OpenSans-Regular.77c09223.ttf";